import React from 'react';
import { KeyCode } from '../constants';
import { BORDER_WIDTH, CONTAINER_VERTICAL_MARGIN, GROUP_ITEM_MARGIN_TOP, SIZE_TO_ITEM_HEIGHT, POPUP_MIN_WIDTH_IN_VIRTUALIZE_CASE, } from './constants';
export const getFlattenOptions = (options) => {
    return options.reduce((acc, option) => {
        if ('label' in option) {
            acc.push({ label: option.label, disabled: true });
            acc.push(...(option.options || []));
        }
        else {
            acc.push(option);
        }
        return acc;
    }, []);
};
export const getPopupItemHeight = (args) => {
    const { getOptionHeight, size, option, index } = args;
    if ('label' in option) {
        const marginTop = index === 0 ? 0 : GROUP_ITEM_MARGIN_TOP;
        return SIZE_TO_ITEM_HEIGHT[size] + marginTop;
    }
    return getOptionHeight ? getOptionHeight(option) : SIZE_TO_ITEM_HEIGHT[size];
};
export const getPopupHeight = (args) => {
    const { getOptionHeight, size, options } = args;
    return options.reduce((height, option, index) => {
        return height + getPopupItemHeight({ getOptionHeight, size, option, index });
    }, 0);
};
export const getPopupVerticalOffset = (args) => {
    const { popupHeight, controlRect } = args;
    if (!controlRect) {
        return BORDER_WIDTH;
    }
    const vh = window.innerHeight / 100;
    const heigth5vh = vh * 5;
    const heigth90vh = vh * 90;
    const containerHeight = heigth90vh < popupHeight ? heigth90vh : popupHeight;
    const popupPlacement = controlRect.y + controlRect.height / 2 < window.innerHeight / 2
        ? 'bottom-start'
        : 'top-start';
    const screenOffset = popupPlacement === 'bottom-start'
        ? window.innerHeight - controlRect.y - controlRect.height
        : controlRect.y;
    let offset = BORDER_WIDTH;
    if (containerHeight > screenOffset) {
        offset = (containerHeight - screenOffset) * -1 - heigth5vh - CONTAINER_VERTICAL_MARGIN;
    }
    return offset;
};
const getOptionText = (option) => {
    if (typeof option.content === 'string') {
        return option.content;
    }
    if (typeof option.children === 'string') {
        return option.children;
    }
    if (option.text) {
        return option.text;
    }
    return option.value;
};
export const getOptionsText = (flattenOptions, value) => {
    return flattenOptions.reduce((acc, option) => {
        if ('label' in option) {
            return acc;
        }
        const optionSelected = value.includes(option.value);
        if (optionSelected) {
            acc.push(getOptionText(option));
        }
        return acc;
    }, []);
};
const getTypedChildrenArray = (children) => {
    return React.Children.toArray(children);
};
const getOptionsFromOptgroupChildren = (children) => {
    return React.Children.toArray(children).reduce((acc, { props }) => {
        if ('value' in props) {
            acc.push(props);
        }
        return acc;
    }, []);
};
export const getOptionsFromChildren = (children) => {
    return getTypedChildrenArray(children).reduce((acc, { props }) => {
        if ('label' in props) {
            const options = props.options || getOptionsFromOptgroupChildren(props.children);
            acc.push({
                options,
                label: props.label,
            });
        }
        if ('value' in props) {
            acc.push(Object.assign({}, props));
        }
        return acc;
    }, []);
};
export const getPopupMinWidth = (virtualizeEnabled, controlRect) => {
    const controlWidth = controlRect === null || controlRect === void 0 ? void 0 : controlRect.width;
    if (virtualizeEnabled && controlWidth) {
        return controlWidth > POPUP_MIN_WIDTH_IN_VIRTUALIZE_CASE
            ? controlWidth
            : POPUP_MIN_WIDTH_IN_VIRTUALIZE_CASE;
    }
    return controlWidth ? controlWidth - BORDER_WIDTH * 2 : undefined;
};
export const getNextQuickSearch = (keyCode, quickSearch) => {
    // https://www.w3.org/TR/uievents-code/#key-alphanumeric-writing-system
    const writingSystemKeyPressed = keyCode.length === 1;
    const backspacePressed = keyCode === KeyCode.BACKSPACE;
    let nextQuickSearch = '';
    if (backspacePressed && quickSearch.length) {
        nextQuickSearch = quickSearch.slice(0, quickSearch.length - 1);
    }
    else if (writingSystemKeyPressed) {
        nextQuickSearch = (quickSearch + keyCode).trim();
    }
    return nextQuickSearch;
};
const getEscapedRegExp = (string) => {
    return new RegExp(string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
};
export const findItemIndexByQuickSearch = (quickSearch, items) => {
    if (!items) {
        return -1;
    }
    return items.findIndex((item) => {
        if ('label' in item) {
            return false;
        }
        if (item.disabled) {
            return false;
        }
        const optionText = getOptionText(item);
        return getEscapedRegExp(quickSearch).test(optionText);
    });
};
export const getListItems = (listRef) => {
    var _a;
    return ((_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.getItems()) || [];
};
export const getActiveItem = (listRef) => {
    var _a;
    const items = getListItems(listRef);
    const activeItemIndex = (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.getActiveItem();
    return typeof activeItemIndex === 'number' ? items[activeItemIndex] : undefined;
};
export const activateFirstClickableItem = (listRef) => {
    var _a;
    const items = getListItems(listRef);
    const isGroupTitleFirstItem = items[0] && 'label' in items[0];
    (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.activateItem(isGroupTitleFirstItem ? 1 : 0);
};
